<template> 
<div> 
    <!-- navbar -->
    <Navbar />
    <!-- header -->
    <PageTitle />
    <!-- carousel -->
    <FeaturesCarousel />
    <!-- Footer -->
    <Footer />
</div>

</template>

<script>
import Navbar from "../components/Navbar";
import PageTitle from "../components/PageTitle.vue"
import FeaturesCarousel from "../components/FeaturesCarousel.vue"
import Footer from "../components/Footer.vue"
    export default{
        name : 'app',
        components: {
            Navbar,
            PageTitle,
            FeaturesCarousel,
            Footer
            },
              methods:{
        i18n(key, args) {
      return this.$t(key, args);
    },
  },
  computed: {
    language(){
      return this.$i18n.locale
    }
  },
  watch: {
    language(){
      document.title = this.i18n("app.title") + " | " + this.i18n('app.industrial');
    }
  } ,
  created(){
      document.title = this.i18n("app.title") + " | " + this.i18n('app.industrial');
  },

  
    };
</script>

<style lang='scss'>
[dir='rtl'] .content{
  text-align: right !important;
}
</style>